import { IKWFSignOptions, IKWFSignDoc } from './services/DialogService';

declare global {
    interface Window {
        CefSharp: CefSharp;
    }
}
interface CefSharp {
    BindObjectAsync(name: string): PromiseLike<any>;
};

export interface InfomaClientIntegration {
    /* Test Method */
    ping(): PromiseLike<"pong">;

    /** Trigger Sign Operation */
    asyncModalSignDocuments(signOptions: IKWFSignOptions, documentInfo: IKWFSignDoc[]): PromiseLike<Partial<IKWFSignDoc>[]>;
}

const InfomaClientIntegration = "InfomaClientIntegration";

/* Aync resolve InfomaClientIntegration or undefined if not available */
export async function AsyncInfomaClientIntegration() {
    if (!window.CefSharp || typeof (window.CefSharp.BindObjectAsync) !== "function") {
        return undefined;
    }
    const result = await window[InfomaClientIntegration] as InfomaClientIntegration;
    if (result) {
        return result;
    }
    await window.CefSharp.BindObjectAsync(InfomaClientIntegration);
    return window[InfomaClientIntegration] as InfomaClientIntegration;
}
